import React from 'react'
import './about.css'
import ME from '../../assets/abhishek_2.jpg'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>1+ Years and Counting</small>
            </article>

            <article className='about__card'>
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>20+ Worldwide</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon' />
              <h5>Projects</h5>
              <small>8+ Completed Projects</small>
            </article>
          </div>

          <p>
            Hello World! I am Abhishek Khandelwal, and I'm a Software Engineer at LTI living in India.
            I joined LTI as my first full-time job. I had interned as a DevOps Engineer, previously
            at Deqode Pvt. Ltd. Here, at LTI, I contribute to the development as a Full Stack Developer.
            But, apart from that, I always tend to look towards the DevOps vertical as well, and I 
            love that Multipotentialite in me. 
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About